module.exports = __webpack_public_path__ + "img/productionBase_2.e5b0babf.png";